/** @format */

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ArchiveRequests from './ArchiveRequests/ArchiveRequests';
import RequestStatsOverview from './RequestStatsOverview/RequestStatsOverview';
import EconomyOverview from './EconomyOverview/EconomyOverview';
import PartsOverview from './PartsOverview/PartsOverview';

@inject('StatsStore')
@observer
class StatsOverview extends Component {
  render() {
    return (
      <div>
        <ArchiveRequests />
        <RequestStatsOverview />
        <EconomyOverview />
        <PartsOverview />
      </div>
    );
  }
}

export default StatsOverview;
